// extracted by mini-css-extract-plugin
export var aiBadge = "recipe-video-preview-module--ai-badge--ee323";
export var video = "recipe-video-preview-module--video--874d7";
export var videoPreview = "recipe-video-preview-module--video-preview--1d2cc";